export function openRadioSilenceDialog(device_id) {
    return {
        type: 'RADIO_SILENCE_DIALOG__OPEN',
        device_id,
    };
}
export function closeRadioSilenceDialog() {
    return {
        type: 'RADIO_SILENCE_DIALOG__CLOSE',
    };
}
export const requestRadioSilence = (device_id, is_radio_silence) => async (dispatch, getState, { api }) => {
    dispatch({
        type: 'REQUEST_RADIO_SILENCE',
        device_id,
        is_radio_silence,
    });
    await api.request_radio_silence(device_id, is_radio_silence);
};
